<template>
  <div class="yn-wrap">
    <header class="seach-header">
      <span>
        <Select placeholder="报告时间" v-model="timeSelect">
          <Option v-for="(d, i) in dateList" :key="i" :value="d.value">{{
            d.name
          }}</Option>
        </Select>
      </span>
      <span>
        <DatePicker
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          v-model="dataRange"
          placeholder="日期范围"
          @on-change="selectDate"
        ></DatePicker>
        <!-- <DatePicker type="daterange" format="yyyy-MM-dd HH:mm:ss"  placeholder="日期范围" v-model="dataRange" @on-change="selectDate"></DatePicker> -->
      </span>
      <span>
        <Input placeholder="姓名或送检医生或检验条码" v-model="keyword" />
      </span>
      <span>
        <Select placeholder="打印状态" v-model="printState">
          <Option v-for="(s, i) in printStateList" :key="i" :value="s.code">{{
            s.name
          }}</Option>
        </Select>
      </span>
      <!-- <span>
        <Select placeholder="状态" v-model="state">
          <Option v-for="(s,i) in stateList" :key="i" :value="s.code">{{s.name}}</Option>
        </Select>
      </span> -->
      <button
        class="ghost"
        @click="search"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
      >
        搜索
      </button>
      <button
        class="ghost"
        @click="reset"
        style="
          margin: 10px 20px 0 0;
          height: 32px;
          padding: 0 15px;
          line-height: 1;
        "
      >
        重置
      </button>
      <button
        class="yn-btn-primary"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
        @click="batchPrint"
      >
        批量打印
      </button>
      <button
        class="yn-btn-primary"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
        @click="LODOPbatchPrint"
      >
        LODOP批量打印
      </button>
      <button
        class="yn-btn-primary"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
        @click="downBatch"
      >
        批量下载
      </button>
      <button
        class="yn-btn-primary"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
        @click="exportCsv"
      >
        数据导出
      </button>
      <button
        class="yn-btn-primary"
        style="height: 32px; padding: 0 15px; line-height: 1; margin-top: 10px"
        @click="exportDetail"
      >
        导出结果明细
      </button>
    </header>
    <section :style="contentStyleObj" ref="table">
      <yn-table
        :ischeckAll="ischeckAll"
        :getTable="tableData"
        @selectAll="selectAll"
        @selectItem="selectItem"
        @detail="detail"
        @printReport="printReport"
        @printReport11="printReport11"
        @SeeReport="SeeReport"
        @SeeReport11="SeeReport11"
        @LODOPSeeport="LODOPSeeport"
        @LODOPSeeport11="LODOPSeeport11"
      ></yn-table>
    </section>
    <footer class="page-table">
      <Page
        :total="total"
        show-total
        show-elevator
        show-sizer
        @on-change="changePage"
        @on-page-size-change="changeSize"
      />
    </footer>
  </div>
</template>
<script>
import YnTable from "./YnTable";
import { baseImg } from "@/config";
import { getLodop } from "@/assets/js/LodopFuncs.js";
import {
  demoDownloadPDF,
  demoOpenLocalPDFfile,
  demoGetLocalFileFullName,
  demoCreatePrinterList,
  demoGetBASE64,
} from "@/assets/js/dayin.js";
import * as A from "@/assets/js/LodopFuncs.js";
import {
  getReport,
  getPrint,
  selectReportByCode,
  reportPrint,
  getPrintJPG,
} from "./../../api/report";
import { dictList, isLogin } from "./../../api/common";
import { tips } from "./../../tools";
import { Form } from "iview";
export default {
  name: "Report",
  components: { YnTable },
  data() {
    return {
      tableHeight: 300,
      total: 0,
      dataRange: ["", ""],
      keyword: "",
      state: "",
      page: 1,
      size: 10,
      ischeckAll: false, //是否全选
      stateList: [],
      tableData: [],
      contentStyleObj: {
        height: "",
      },
      patientName: "", //姓名
      sampType: "", //样本类型
      clinicNo: "", //门诊号
      sex: "", //性别
      sampleAppearance: "", //样品性状
      department: "", //科室
      companyCode: "", //公司条码
      age: "", //年龄
      sumbitDoctor: "", //送检医生
      clinicalImpression: "", //临床印象
      bedNumber: "", //床号
      hospitalCode: "", //院方编码
      inspectionUnit: "", //送检单位
      proofer: "", //检验者
      auditor: "", //审核者
      approver: "", //批准人
      acquisitionTime: "", //采集时间
      receiptTime: "", //接收时间
      reportTime: "", //报告时间
      adress: "", //地址
      telPhone: "", //电话
      url: "",
      postCode: "", //邮编
      projectItems: [],
      userId: "",
      timeSelect: 1,
      JPGURL: "",
      pictureURL: "",
      dateList: [
        {
          value: 1,
          name: "报告时间",
        },
        {
          value: 0,
          name: "接收时间",
        },
      ],
      printState: "",
      printStateList: [],
    };
  },
  mounted() {
    // window.addEventListener('resize', this.getTableHeight(90));
    this.getTableHeight();
    this.getUser();
    this.init();
  },
  methods: {
    getReportModal(id) {
      selectReportByCode({
        id: id,
      }).then((res) => {
        console.log(res);
        let data = res;
      });
    },
    //调取打印
    createPrintPage(id) {
      var LODOP = getLodop();
      LODOP.PRINT_INIT("检验报告单");
      LODOP.PRINT_INITA(0, 0, "210mm", "297mm", "");
      LODOP.SET_PRINT_PAGESIZE(1, 2200, 0, "A4");
      let projectItems = this.projectItems;
      let liHtml = "";
      // console.log(projectItems);
      for (let i = 0; i < projectItems.length; i++) {
        liHtml += `<li style="display:flex;justify-content:space-between;line-height:26px;font-size:14px;">
        <span style="padding-left:10px;text-align:left;width:11%;">${
          projectItems[i].itemEn ? projectItems[i].itemEn : "/"
        }</span>
        <span style="text-align:left;width:30%;">${
          projectItems[i].itemName ? projectItems[i].itemName : "/"
        }</span>
        <span style="text-align:left;width:14%;">${
          projectItems[i].result ? projectItems[i].result : "/"
        }</span>
        <span style="text-align:left;width:12%;">${
          projectItems[i].flag ? projectItems[i].flag : ""
        }</span>
        <span style="text-align:left;width:14%;">${
          projectItems[i].unit ? projectItems[i].unit : "/"
        }</span>
        <span style="text-align:left;width:29%;">${
          projectItems[i].referValue ? projectItems[i].referValue : "/"
        }</span>
      </li>`;
        // console.log(itemHtml);
      }
      let titleHtml = `<div class="re-container" style="margin-left:4%;width:96%;font-family:'STSong','华文宋体','宋体',Microsoft YaHei',Arial,Helvetica,sans-serif;">
          <div class="baseInfo" style="font-size:14px;width:100%;border-top:2px solid #000;border-bottom:2px solid #000;margin:0;padding:0;">
            <ul style="padding:0 0 3px 0;margin:0;">
              <li style="display:flex;justify-content:space-between;height:30px;line-height:30px;padding-left:5px;">
                <span style="width:22%;">姓　名：${
                  this.patientName ? this.patientName : "/"
                }</span>
                <span style="width:24%;">样品类型：${
                  this.sampType ? this.sampType : "/"
                }</span>
                <span style="width:54%;">门诊 / 住院号：${
                  this.clinicNo ? this.clinicNo : "/"
                }</span>
              </li>
              <li style="display:flex;justify-content:space-between;height:30px;line-height:30px;padding-left:5px;">
                <span style="width:22%;">性　别：${
                  this.sex ? this.sex : "/"
                }</span>
                <span style="width:24%;">样品性状：${
                  this.sampleAppearance ? this.sampleAppearance : "/"
                }</span>
                <span style="width:22%;">科室 / 病区：${
                  this.department ? this.department : "/"
                }</span>
                <span style="width:32%;">公司条码：${
                  this.companyCode ? this.companyCode : "/"
                }</span>
              </li>
              <li style="display:flex;justify-content:space-between;height:30px;line-height:30px;padding-left:5px;">
                <span style="width:22%;">年　龄：${
                  this.age ? this.age : "/"
                }</span>
                <span style="width:24%;">送检医生：${
                  this.sumbitDoctor ? this.sumbitDoctor : "/"
                }</span>
                <span style="width:54%;">临床印象：${
                  this.clinicalImpression ? this.clinicalImpression : "/"
                }</span>
              </li>
              <li style="display:flex;justify-content:space-between;height:30px;line-height:30px;padding-left:5px;">
                <span style="width:22%;">床　号：${
                  this.bedNumber ? this.bedNumber : "/"
                }</span>
                <span style="width:24%;">院方条码：${
                  this.hospitalCode ? this.hospitalCode : "/"
                }</span>
                <span style="width:54%;">送检单位：${
                  this.inspectionUnit ? this.inspectionUnit : "/"
                }</span>
              </li>
            </ul>
          </div>
          <div style="font-size:18px;width:100%;border-bottom:1px solid #000;height:34px;line-height:34px;padding-bottom:4px;padding:0;">
            <section style="display:flex;justify-content:space-between;padding:0 5px;font-size:15px;">
              <span style="text-align: left;width: 11%;">简称</span>
              <span style="text-align: left;width: 30%;">项目</span>
              <span style="text-align: left;width: 14%;">结果</span>
              <span style="text-align: left;width: 12%;">提示</span>
              <span style="text-align: left;width: 14%;">单位</span>
              <span style="text-align: left;width: 29%;">参考区间</span>
            </section>
          </div>`;
      let itemHtml =
        `<div style="width:96%;margin-left:4%;font-size:13px;"><ul style="width:100%;padding:0;">
        ` +
        liHtml +
        liHtml +
        liHtml +
        `</ul></div>`;
      let footHtml = `<div class="foot" style="margin-left:4%;width:96%;margin-top:4px;border-top:1px solid #000;">
        <div style="width:100%;height:3px;"></div>
        <div style="padding-left:5px;font-size:16px;margin-top:2px;border-top:2px solid #000;display:flex;justify-content:space-between;">
          <section style="width:33.3%;height:30px;line-height:30px;">
            <span style="font-weight:600;">检验者：</span>
            <span>${this.proofer ? this.proofer : "/"}</span>
          </section>
          <section style="width:33.3%;height:30px;line-height:30px;">
            <span style="font-weight:600;">审核者：</span>
            <span>${this.auditor ? this.auditor : "/"}</span>
          </section>
          <section style="width:33.3%;height:30px;line-height:30px;">
            <span style="font-weight:600;">批准人：</span>
            <span>${this.approver ? this.approver : "/"}</span>
          </section>
        </div>
        <div style="padding-left:5px;font-size:13px;display:flex;justify-content:space-between;">
          <section style="width:33.3%;height:26px;line-height:26px;">
            <span>采集时间：${
              this.acquisitionTime ? this.acquisitionTime : "/"
            }</span>
          </section>
          <section style="width:33.3%;height:26px;line-height:26px;">
            <span>接收时间：${this.receiptTime ? this.receiptTime : "/"}</span>
          </section>
          <section style="width:33.3%;height:26px;line-height:26px;">
            <span>报告时间：${this.reportTime ? this.reportTime : "/"}</span>
          </section>
        </div>
        <div style="padding-left:5px;font-size:14px;display:block;">
          <section style="height:26px;line-height:26px;">本检测结果进队来样负责，供临床参考。如有疑问请参见医诺检测目录。</section>
        </div>
        <div style="padding-left:5px;font-size:14px;display:flex;">
          <section style="height:26px;line-height:26px;">
            <span>报告无检验者、审核者、批准人签字无效。</span>
          </section>
        </div>
        <div style="padding-left:5px;font-size:14px;display:flex;">
          <section style="height:26px;line-height:26px;">
            <span>地址：</span>
            <span>${this.adress ? this.adress : "/"}</span>
          </section>
        </div>
        <div style="padding-left:5px;font-size:14px;display:flex;justify-content:space-between;">
          <section style="width:33.3%;height:26px;line-height:26px">
            <span>电话:</span>
            <span>${this.telPhone ? this.telPhone : "/"}</span>
          </section>
          <section style="width:33.3%;height:26px;line-height:26px">
            <span>网址:</span>
            <span>${this.url ? this.url : "/"}</span>
          </section>
          <section style="width:33.3%;height:26px;line-height:26px">
            <span>邮编：</span>
            <span>${this.postCode ? this.postCode : "/"}</span>
          </section>
        </div>
        </div></div>`;

      LODOP.PRINT_INITA(0, 0, "210mm", "296.99mm", "");
      LODOP.SET_PRINT_PAGESIZE(1, 2200, 0, "A4");
      LODOP.ADD_PRINT_HTM(110, 0, "100%", 165, titleHtml);
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
      LODOP.ADD_PRINT_HTM(280, 0, "100%", 652, itemHtml);
      LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
      LODOP.ADD_PRINT_HTM(940, 5, "100%", 174, footHtml);
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      LODOP.SET_PRINT_STYLEA(0, "Horient", 2);
      LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      LODOP.ADD_PRINT_TEXT(
        50,
        230,
        "50%",
        30,
        "杭州医诺云检医学检验实验室有限公司"
      );
      LODOP.SET_PRINT_STYLEA(0, "FontName", "新宋体");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      LODOP.ADD_PRINT_TEXT(80, 360, "20%", 30, "检验报告");
      LODOP.SET_PRINT_STYLEA(0, "FontSize", 16);
      LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      LODOP.ADD_PRINT_IMAGE(
        50,
        30,
        200,
        67,
        `<img src='${baseImg}appLogo.png'>`
      );
      LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
      LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);
      LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 1);
      LODOP.NEWPAGEA();
      //强制分页
      // LODOP.PREVIEW();
      // LODOP.PRINT_SETUP();
      // LODOP.PRINT_DESIGN();
      // ADD_PRINT_URL(intTop,intLeft,intWidth,intHeight,strURL);
      LODOP.PREVIEW();
    },
    getTableHeight() {
      this.contentStyleObj.height = window.innerHeight - 266 - 60 + "px";
    },
    init() {
      dictList().then((res) => {
        this.printStateList = res.filter(
          (item) => item.t === "report_print_state"
        )[0].list;
        this.stateList = res.filter(
          (item) => item.t === "process_state"
        )[0].list;
        this.getList();
      });
    },
    getList() {
      getReport({
        current: this.page,
        beginTime: this.dataRange[0],
        endTime: this.dataRange[1],
        keyword: this.keyword,
        size: this.size,
        state: this.state,
        timeType: this.timeSelect,
        printState: this.printState,
      }).then((res) => {
        res.records.map((item) => {
          for (let i in this.stateList) {
            if (this.stateList[i].code == item.processState) {
              item.processStateName = this.stateList[i].name;
            }
          }
        });
        this.tableData = [...res.records];
        console.log(this.tableData);
        this.total = res.total;
      });
    },
    //批量打印
    batchPrint() {
      let arr = this.tableData.filter((item) => item.checked);
      if (arr.length === 0) {
        tips(this, "请至少选择一项", "warning");
        return false;
      } else {
        let arrId = [];
        arr.map((i) => arrId.push(i.orderReport));
        let arr2 = [];
        for (let i in arrId) {
          for (let j in arrId[i]) {
            arr2.push(arrId[i][j].orderReportId);
          }
        }
        console.log(arr2.join(","));
        this.SeeReportPDF(arr2.join(","));
      }
    },
    LODOPbatchPrint() {
      let arr = this.tableData.filter((item) => item.checked);
      if (arr.length === 0) {
        tips(this, "请至少选择一项", "warning");
        return false;
      } else {
        let arrId = [];
        arr.map((i) => arrId.push(i.orderReport));
        let arr2 = [];
        for (let i in arrId) {
          for (let j in arrId[i]) {
            arr2.push(arrId[i][j].orderReportId);
          }
        }
        console.log(arr2.join(","));
        this.SeeReportJPG(arr2.join(","));
      }
    },
    LODOPSeeport11(obj) {
      const { m, orderReportId } = obj;
      if (m.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        // this.SeeReportJPG(ids.join(","));
        let LODOP = getLodop();
        if (LODOP == undefined) {
          return;
        }
        getPrintJPG({
          ids: ids.join(","),
          type: 1,
          userType: 1,
          userId: this.userId,
        }).then((res) => {
          LODOP.PRINT_INIT("检验报告单");
          console.log(res);
          if (res[0].pageType == "A4") {
            const pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[0].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
            LODOP.ADD_PRINT_URL(0, 0, "100%", "100%", pictureURL);
            LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
          } else if (res[0].pageType == "A5") {
            console.log(jkl)
            let pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[0].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
            LODOP.ADD_PRINT_URL(0, 0, "100%", "100%", pictureURL);
            LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
            LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
            LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED",1);//横向时的正向显示
          }
          LODOP.PREVIEW();
        });
      }
      this.getList();
    },
    exportCsv() {
      let ids = this.getSelectIds();
      // window.open(
      //   `${this.$url}clinic-manager/report/excelOrderList?ids=${ids}`
      // );
      if (ids) {
        let xhr = new XMLHttpRequest();
        let formData = new FormData();

        xhr.open(
          "get",
          `${this.$url}clinic-manager/report/excelOrderList?ids=${ids}`,
          true
        );
        xhr.setRequestHeader("token", localStorage.getItem("his_token"));
        xhr.responseType = "blob";
        xhr.onload = function (e) {
          if (this.status == 200) {
            let blob = this.response;
            console.log(blob);
            let data = new Blob([blob], { type: "application/vnd.ms-excel" });
            console.log(data.size);
            let downloadUrl = window.URL.createObjectURL(data);
            console.log(downloadUrl);
            let anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download =
              "医诺云检HIS" + new Date().toLocaleTimeString() + ".xls";
            anchor.click();
            window.URL.revokeObjectURL(data);
          }
        };
        xhr.send(formData);
      }
    },
    //导出明细
    exportDetail() {
      let beginTime = this.dataRange[0];
      let endTime = this.dataRange[1];
      // if(beginTime&&endTime){
      let keyword = this.keyword;
      let timeType = this.timeSelect;
      let printState = this.printState;
      let xhr = new XMLHttpRequest();
      let formData = new FormData();
      xhr.open(
        "get",
        `${this.$url}clinic-manager/report/excelReportResult?beginTime=${beginTime}&endTime=${endTime}&keyword=${keyword}&timeType=${timeType}&printState=${printState}`,
        true
      );
      xhr.setRequestHeader("token", localStorage.getItem("his_token"));
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        if (this.status == 200) {
          let blob = this.response;
          console.log(blob);
          let data = new Blob([blob], { type: "application/vnd.ms-excel" });
          console.log(data.size);
          let downloadUrl = window.URL.createObjectURL(data);
          console.log(downloadUrl);
          let anchor = document.createElement("a");
          anchor.href = downloadUrl;
          anchor.download =
            "医诺云检HIS" + new Date().toLocaleTimeString() + ".xls";
          anchor.click();
          window.URL.revokeObjectURL(data);
        }
      };
      xhr.send(formData);
      // }else{
      //   tips(this, "请选择时间段", "warning");
      // }
    },
    //详情
    detail(id) {
      this.$router.push(`/detail/${id}`);
    },
    downBatch() {
      let ids = this.getSelectIds();
      if (ids) {
        window.open(`${this.$url}common/common/reportBatchDownload?ids=${ids}`);
      }
    },
    getSelectIds() {
      let arr = this.tableData.filter((item) => item.checked);
      if (arr.length === 0) {
        tips(this, "请至少选择一项", "warning");
        return false;
      } else {
        let arrId = [];
        arr.map((i) => arrId.push(i.orderId));
        return arrId.join(",");
      }
    },
    LODOPSeeport(obj) {
      const { arr, reportTitle, orderReportId } = obj;
      if (arr.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        ids.join(",");
        console.log(ids.join(","));
                let LODOP = getLodop();
        if (LODOP == undefined) {
          return;
        }
        getPrintJPG({
          ids: ids.join(","),
          type: 1,
          userType: 1,
          userId: this.userId,
        }).then((res) => {
          LODOP.PRINT_INIT("检验报告单");
          console.log(res);
          if (res[0].pageType == "A4") {
            const pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[0].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
            LODOP.ADD_PRINT_URL(0, 0, "100%", "100%", pictureURL);
            LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
          } else if (res[0].pageType == "A5") {
            console.log("111111111111111111111111")
            let pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[0].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
            LODOP.ADD_PRINT_URL(0, 0, "100%", "100%", pictureURL);
            LODOP.SET_PRINT_PAGESIZE(2,0,0,"A5");
            // LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW", true);
            // LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW", true);
            LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
           LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED",1);//横向时的正向显示
          }
          LODOP.PREVIEW();
        });
      }
      this.getList();
    },
    printReport11(obj) {
      console.log(obj);
      const { m, orderReportId } = obj;
      if (m.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        console.log(1221321);
        this.SeeReportPDF(ids.join(","));
      }
    },
    //报告
    printReport(obj) {
      const { arr, reportTitle, orderReportId } = obj;
      if (arr.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        this.getPDFReport(ids.join(","));
      }
    },
    SeeReport11(obj) {
      console.log(obj);
      const { m, orderReportId } = obj;
      if (m.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        this.SeeReportPDF(ids.join(","));
      }
    },
    SeeReport(obj) {
      const { arr, reportTitle, orderReportId } = obj;
      if (arr.length === 0) {
        tips(this, "没有报告单", "warning");
      } else {
        let ids = [];
        ids.push(orderReportId);
        this.SeeReportPDF(ids.join(","));
      }
    },
    getUser() {
      isLogin().then((res) => {
        this.userId = res.userId;
      });
    },
    getPDFReport(ids) {
      getPrint({ ids, type: 0, userType: 1, userId: this.userId }).then(
        (res) => {
          // const resid = res.id
          window.open(
            `${this.$url}common/common/downLoadFile?attachId=${res.id}&type=0`
          );
        }
      );
    },
    SeeReportJPG(ids) {
      let LODOP = getLodop();
      console.log(LODOP);
      if (LODOP == undefined) {
        return;
      }
      getPrintJPG({ ids, type: 1, userType: 1, userId: this.userId }).then(
        (res) => {
          LODOP.PRINT_INIT("检验报告单");
          for (let i = 0; i < res.length; i++) {
            if (res[i].pageType == "A5") {
              let pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[i].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
              let JPGURL = '<img src="' + pictureURL + '"/>';
              console.log(JPGURL);
              LODOP.ADD_PRINT_IMAGE(0, 0, "100%", "100%", JPGURL);
              LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
              LODOP.NewPage();
            } else if (res[i].pageType == "A4") {
              console.log(res[i].jpgId);
              const pictureURL = `${this.$url}common/common/downLoadFile?attachId=${res[i].jpgId}&type=0&outputQuality=0.1&scale=0.5`;
              // let JPGURLs = "<img src=\""+pictureURL+"\"/>"
              // LODOP.ADD_PRINT_IMAGE(0,0,"210mm","296mm",JPGURLs);
              // // LODOP.SET_PRINT_STYLEA(0,"HtmWaitMilSecs",10000)
              // LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
              // LODOP.NEWPAGEA();
              console.log(pictureURL, 111111111);
              LODOP.ADD_PRINT_URL(0, 0, "100%", "100%", pictureURL);
              // LODOP.SET_PRINT_MODE("FULL_WIDTH_FOR_OVERFLOW",true);
              // LODOP.SET_PRINT_MODE("FULL_HEIGHT_FOR_OVERFLOW",true);
              LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Auto-Width");
              LODOP.NewPage();
            }
          }
          LODOP.PREVIEW();
        }
      );
    },
    SeeReportPDF(ids) {
      getPrint({ ids, type: 1, userType: 1, userId: this.userId }).then(
        (res) => {
          window.open(
            `${this.$url}common/common/downLoadFile?attachId=${res.id}&type=0`
          );
          this.getList();
        }
      );
    },
    //选择日期
    selectDate(d) {
      console.log(d);
      this.dataRange = d;
    },
    selectAll(b) {
      this.tableData.map((item) => (item.checked = b));
      this.tableData = [...this.tableData];
    },
    //单选
    selectItem(i) {
      // ischeckAll
      // console.log(i);
      this.tableData.map((item) => {
        if (item.orderId == i) {
          item.checked = !item.checked;
        }
      });
      let select = this.tableData.filter((item) => item.checked);
      this.ischeckAll = select.length === this.tableData.length ? true : false;
      this.tableData = [...this.tableData];
    },
    search() {
      this.page = 1;
      this.getList();
    },
    //重置
    reset() {
      this.dataRange = ["", ""];
      this.page = 1;
      this.size = 10;
      this.state = "";
      this.keyword = "";
      this.printState = "";
      this.getList();
    },
    changePage(page) {
      this.page = page;
      this.getList();
    },
    changeSize(size) {
      this.page = 1;
      this.size = size;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.seach-header > button {
  padding: 5px 15px 6px;
  margin-right: 10px;
}
section > div {
  height: 100%;
  overflow: scroll;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
</style>





// WEBPACK FOOTER //
// src/views/report/ReportQuery.vue